import React from 'react';
import Tab from 'housecall-ui/dist/DesignSystem/Navigation/Tabs/Tab';

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
const TabLink = React.forwardRef<any, any>(({ href, ...props }, ref) => {
  return <Tab {...props} component="a" ref={ref} href={href} />;
});

TabLink.displayName = 'TabLink';

export default TabLink;
